import React from 'react';
import { Phone, Mail, Instagram as InstagramIcon } from 'lucide-react'; // Renamed to avoid conflict

export default function Contact() {
  return (
    <div className="container mx-auto px-4 pt-24 pb-12 text-gray-800">
      <h1 className="text-4xl font-bold mb-8 text-center text-brand-secondary">Get In Touch</h1>
      
      <p className="text-lg text-center mb-10 max-w-xl mx-auto">
        We're here to help with any questions you have about Market Bloom, your orders, or partnering with us. Please don't hesitate to reach out!
      </p>

      <div className="max-w-lg mx-auto">
        {/* Contact Methods Section */}
        <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md">
          <h2 className="text-3xl font-semibold mb-8 text-center text-brand-primary">Contact Information</h2>
          
          <div className="space-y-6">
            <div className="flex items-start">
              <Phone className="w-6 h-6 text-brand-primary mr-4 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold text-brand-secondary">Phone Support</h3>
                <a href="tel:1800FLOWERS" className="text-lg text-gray-700 hover:text-brand-primary">1800 FLOWERS</a>
                <p className="text-sm text-gray-500">Available Mon-Fri, 9am - 5pm AEST</p>
              </div>
            </div>

            <div className="flex items-start">
              <Mail className="w-6 h-6 text-brand-primary mr-4 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold text-brand-secondary">Email Support</h3>
                <a href="mailto:info@marketbloom.com.au" className="text-lg text-gray-700 hover:text-brand-primary">info@marketbloom.com.au</a>
                <p className="text-sm text-gray-500">We typically respond within 24 hours.</p>
              </div>
            </div>

            <div className="flex items-start">
              <InstagramIcon className="w-6 h-6 text-brand-primary mr-4 mt-1 flex-shrink-0" /> 
              <div>
                <h3 className="text-xl font-semibold text-brand-secondary">Social Media</h3>
                <a 
                  href="https://instagram.com/marketbloom" 
                  className="text-lg text-gray-700 hover:text-brand-primary underline"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  @marketbloom
                </a>
                <p className="text-sm text-gray-500">Follow us for updates and inspiration!</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12 text-center">
        <p className="text-md text-gray-600 max-w-xl mx-auto">
          For urgent matters regarding an existing order, please call us directly for the quickest assistance. Our team is ready to help you.
        </p>
      </div>
    </div>
  );
} 